import React, { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { CalculatorRedirectHomeContext } from '../contexts/CalculatorContext';
import { useCalculatorNavigate } from '../utils/calculatorNavigate';

export function RedirectToHome(): JSX.Element {
    const navigate = useCalculatorNavigate();
    const redirectHomeContext = useContext(CalculatorRedirectHomeContext)!;

    useEffect(() => {
        if (redirectHomeContext[0]) {
            navigate('home');
        }
    });

    return (
        <Outlet/>
    );
}
